const TOOL_TITLE_KEYS = {
    tasks: 'page_title.Checklist',
    registers: 'page_title.Register',
    audits: 'page_title.Audit',
    actionPlans: 'page_title.ActionPlan',
    sensors: 'page_title.Sensor',
    library: 'page_title.Library',
    incidents: 'page_title.Issues'
}

/**
 * @param {string} tool
 * @returns {string}
 */
export function getAndyAgentsToolTitleKey(tool) {
    if (!tool || !Object.prototype.hasOwnProperty.call(TOOL_TITLE_KEYS, tool)) {
        return ''
    }
    return TOOL_TITLE_KEYS[tool]
}
